import { Link } from "react-router";
import { useCookieConsent } from "~/lib/hooks/use-cookie-consent";

export function CookieConsentBanner() {
	const { consent, accept, reject, mounted } = useCookieConsent();

	if (!mounted || consent !== "pending") return null;

	return (
		<div className="fixed bottom-0 left-0 right-0 z-50 border-t border-base-300 bg-base-100 px-6 py-4 shadow-lg">
			<div className="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
				<p className="text-sm text-base-content/80">
					Používáme cookies pro zajištění základní funkčnosti webu. S vaším souhlasem také cookies
					pro analýzu návštěvnosti.{" "}
					<Link to="/cookie-policy" className="underline hover:text-primary">
						Zásady cookies
					</Link>
				</p>
				<div className="flex shrink-0 gap-2">
					<button type="button" onClick={reject} className="btn btn-ghost btn-sm">
						Odmítnout
					</button>
					<button type="button" onClick={accept} className="btn btn-primary btn-sm">
						Přijmout vše
					</button>
				</div>
			</div>
		</div>
	);
}
